import * as TK from 'components/auth/SocialAuthProviders/translations/constants';
import { Translations } from 'translations/types';

export const authProvidersEnUsLocale: Translations = {
  [TK.AUTH_PROVIDERS_TITLE]: 'Or sign up with',
};
